import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  &.lessThanTwoTop {
    min-height: auto;
    background: transparent;
    margin-top: -7px;
    backdrop-filter: none;
  }

  border-bottom: 3px solid ${(p) => p.theme.palette.primary[500]};
  position: absolute;
  z-index: 999;
  right: 0;
  left: 0;
  display: flex;
`;
